import { render, staticRenderFns } from "./type_pret.vue?vue&type=template&id=2baafab2"
import script from "./type_pret.vue?vue&type=script&lang=js"
export * from "./type_pret.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports